import { FullPageSpinner } from '@wyz/ui';
import { useOnMount } from '@wyz/utils';
import { useNavigate } from 'react-router';
import { ROLES } from '~/common/helpers';
import { useAccessControl } from '~/common/hooks';
import { SEARCH_ROUTES } from '~/purchase/helpers';

const PostSignIn = () => {
  const navigate = useNavigate();
  const acl = useAccessControl();

  useOnMount(() => {
    const replaceOpt = {
      replace: true,
    };
    if (
      acl.isGranted([ROLES.ROLE_LIST_OFFERS]) ||
      acl.isGranted([ROLES.ROLE_LIST_REDISTRIBUTION_OFFERS])
    ) {
      void navigate(SEARCH_ROUTES.PURCHASE, replaceOpt);
    } else {
      void navigate('/', replaceOpt);
    }
  });
  return <FullPageSpinner />;
};

export default PostSignIn;
